import React, { useMemo } from 'react';
import ImgPicuter from '@components/img-picture';
const ColumnItem = ({ columnItem }) => {
    const idName = useMemo(() => {
        return `COLUMN_${columnItem.image_name}`;
    }, [
        columnItem
    ]);
    return (React.createElement("div", { className: "column-item" },
        React.createElement("div", { className: "column-item-image" },
            React.createElement("a", { href: columnItem.url, target: "_blank", id: idName },
                React.createElement(ImgPicuter, { fileName: `./assets/img/column-item/${columnItem.image_name}`, alt: columnItem.name, ext: 'jpg', lazyload: true }))),
        React.createElement("div", { className: "column-item-name" },
            React.createElement("a", { href: columnItem.url, target: "_blank", "data-label-hover": "\u30B3\u30E9\u30E0\u3092\u8AAD\u3080", id: idName }, columnItem.name))));
};
export default ColumnItem;
